<template>
  <section class="hero is-primary is-fullheight">
    <div class="hero-body main-title">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-5-tablet is-4-desktop is-3-widescreen">
            <form action="" @submit.prevent="handleAuth" class="box">
              <div class="content">
                <h4>Login to</h4>
                <img class="main-logo" src="@/assets/everestAsset1.png" />
                <p class="is-size-7">
                  <u>modular</u> 🎌 <u>feature ritch</u> 🎌 <u>cloud based</u>
                  <br /><strong>Access Control</strong> and
                  <strong>T&A</strong> system
                </p>
              </div>
              <!-- Username field -->
              <div class="field">
                <label for="" class="label">Username</label>
                <div class="control has-icons-left">
                  <input
                    type="mail"
                    v-model="username"
                    placeholder="enter username"
                    class="input has-text-centered has-background-info-light"
                    required
                  />
                  <span class="icon is-small is-left">
                    <font-awesome-icon icon="user" />
                  </span>
                </div>
              </div>
              <!-- Password field -->
              <div class="field">
                <label for="" class="label">Password</label>
                <div class="control has-icons-left">
                  <input
                    type="password"
                    placeholder="*******"
                    v-model="password"
                    class="input has-text-centered has-background-info-light"
                    required
                  />
                  <span class="icon is-small is-left">
                    <font-awesome-icon icon="lock" />
                  </span>
                </div>
              </div>
              <!-- Login button -->
              <div class="field">
                <button
                  class="button is-info is-light is-rounded"
                  v-bind:class="{ 'is-loading': loading }"
                >
                  Login
                </button>
              </div>
              <!-- Error message -->
              <div>
                <label>{{ errorMessage }}</label>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Particles effect -->
    <vue-particles
      class="particles-js"
      color="#dedede"
      :particleOpacity="0.7"
      :particlesNumber="80"
      shapeType="circle"
      :particleSize="4"
      linesColor="#dedede"
      :linesWidth="1"
      :lineLinked="false"
      :lineOpacity="0.1"
      :linesDistance="150"
      :moveSpeed="3"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="push"
    ></vue-particles>
  </section>
  <!-- <HelloWorld msg="Jajara - everest portal" /> -->
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
// import { mapState } from "vuex";

export default {
  name: "Login",
  components: {
    // ValidationError,
  },
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      message: "",
      errorMessage: "",
    };
  },
  computed: {
    // ...mapState({
    //   errorMessage: (state) => state.alert.message,
    // }),
    loggingIn() {
      return this.$store.state.authentication.status.loggingIn;
    },
  },
  created() {
    // reset login status
    this.$store.dispatch("auth/logout");
  },
  methods: {
    handleAuth() {
      this.loading = true;
      const { username, password } = this;
      const { dispatch } = this.$store;
      if (username && password) {
        dispatch("auth/login", { username, password }).then(
          () => {
            this.$router.push("/");
          },
          (error) => {
            this.loading = false;
            this.errorMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        );
      }
    },
  },
};
</script>

<style scoped>
.interactive-bg {
  height: 100vh;
  background-color: #00d1b2;
  -webkit-box-shadow: inset 24px 4px 64px -24px rgba(71, 71, 71, 1);
  -moz-box-shadow: inset 24px 4px 64px -24px rgba(71, 71, 71, 1);
  box-shadow: inset 24px 4px 64px -24px rgba(71, 71, 71, 1);
  padding: 0px;
}
@media (max-width: 769px) {
  .interactive-bg {
    display: none;
  }
}

.input {
  border-radius: 50px;
}

.button {
  margin-top: 20px;
  margin-bottom: 20px;
  min-width: 150px;
}

.login-logo {
  margin: 0 auto;
  margin-bottom: 50px;
  max-height: 100px;
}

.columns {
  margin: 0px;
}

.particles-js {
  background-image: url("../assets/sky.jpg");
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.main-title {
  z-index: 999;
}

/* main logo */
.main-logo {
  margin-top: 10px;
  margin-bottom: 30px;
  width: 160px;
}
</style>
